import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  ConnectedUsers: {
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  Avatar: {
    verticalAlign: "middle",
    marginRight: "15px",
    textTransform: "uppercase",
    height: 34,
    width: 34,
    border: "thin solid rgba(0, 0, 0, 0.10)",
    borderRadius: "5px",
    "&:hover": {
      cursor: "pointer",
      backgroundImage: "linear-gradient(#E5E5E5, #CFCFCF)"
    }
  },
  AvatarInitiales: {
    verticalAlign: "middle",
    marginRight: "15px",
    textTransform: "uppercase",
    height: 34,
    width: 34,
    border: "thin solid rgba(0, 0, 0, 0.10)",
    color: "grey",
    backgroundColor: "white",
  }
}));
